// extracted by mini-css-extract-plugin
module.exports = {"intro-text":"BrandLogos-module--intro-text--3iTAD","logo-image":"BrandLogos-module--logo-image--kl2E4"};